<template>
  <v-form lazy-validation>
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs12>
          <v-layout wrap>
            <v-flex xs12>
              <!--<v-text-field
                :error-messages="nameErrors"
                prepend-icon="label"
                v-model="$v.visitForm.name.$model"
                label="Nombre de la cita"
                clearable
                counter
                maxlength="100"
                required
              />--->
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :error-messages="reasonErrors"
                prepend-icon="subject"
                v-model="$v.visitForm.reason.$model"
                label="Asunto"
                rows="2"
                auto-grow
                clearable
                counter
                maxlength="100"
              />
            </v-flex>

            <v-flex xs12>
              <v-autocomplete
                v-model="model"
                :error-messages="collaboratorErrors"
                :items="collaborators"
                :item-text="collaboratorName"
                item-value="id"
                prepend-icon="person"
                label="¿A quién visita?"
                @change="onChanged"
                hide-selected
              >
              
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition
                mode="out-in"
              >
              </v-slide-x-reverse-transition>
            </template>

            </v-autocomplete>
            <v-chip v-for="(chipText , index) in chipData" :key="index" @click="onRemove(chipText.id)" class="gradiente white--text">{{`${chipText.firstName} ${chipText.lastName}`}}<v-icon right small>cancel</v-icon></v-chip>

              <!-- <v-select
                :error-messages="collaboratorErrors"
                :items="collaborators"
                prepend-icon="person"
                v-model="$v.visitForm.idCollaborator.$model"
                item-value="id"
                :item-text="collaboratorName"
                @change="onChanged"
                clearable
                label="¿A quién visita?"
                required
              ></v-select> -->
            </v-flex>
            <v-flex xs12 v-show="$v.visitForm.visitType.$model=='ONLY_ONCE'">
              <VisitEditTimeDate
                :errorMessages="dateErrors"
                titleDate="Fecha"
                titleTime="Hora"
                v-model="$v.visitForm.date.$model"
                style=""
                :min="today"
                location="up"
              />
            </v-flex>
            <v-flex xs12 v-show="$v.visitForm.visitType.$model=='RANGE'">
              <VisitEditTimeDate
                :errorMessages="startDateErrors"
                titleDate="Fecha inicial"
                titleTime="Hora"
                v-model="$v.visitForm.startDate.$model"
                style=""
                :min="today"
                location="up"
              />

              <VisitEditTimeDate
                :errorMessages="endDateErrors"
                titleDate="Fecha de término"
                titleTime="Hora"
                v-model="$v.visitForm.endDate.$model"
                style=""
                :min="today"
                location="up"
              />
            </v-flex>

            <v-flex v-if="peopleMode">
              <v-select
                :items="modes"
                prepend-icon="call_split"
                v-model="$v.visitForm.peopleMode.$model"
                item-value="id"
                item-text="label"
                label="Modo de invitación"
                required
              ></v-select>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// import DateTimePicker from "../Notices/Tools/DateTimePicker2";
import VueTimePickerTool from '../Notices/Tools/VueDateTimePicker'
import VisitEditTimeDate from './VisitEditTimeDate.vue'


export default {
  props: ['visitForm', 'collaborators', 'peopleMode', 'host_custon_hosts'],
  components: {
    // DateTimePicker,
    VueTimePickerTool,
    VisitEditTimeDate
  },
  validations: {
    visitForm: {
      name: { required },
      reason: {
        required: false,
      },
      idCollaborator: {},
      date: {},
      startDate: {},
      endDate: {},
      visitType: { required },
      peopleMode: {
        required: false,
      },
    },
  },
  mounted() {
    this.today = new Date().toLocaleDateString('sv-SE')
    if (this.$v.visitForm) {
      this.$emit('formMounted', this.$v.visitForm)
    }
  },
  data: () => ({
    model: null,
    chipData: {},
    today: '',
    modes: [
      {
        id: 'MANUAL',
        label: 'Manual',
      },
      {
        id: 'AUDIENCE',
        label: 'Audiencia',
      },
    ],
	periodicity: [
      {
        type: 'ONLY_ONCE',
        text:'Para una sola vez'
      },
      {
        type: 'RANGE',
        text:'Para un periodo'
      },
    ],
  }),
  watch:{
    'host_custon_hosts': function (newVal, _) {
      this.chipData = newVal.hosts
    }
  },
  methods: {
    collaboratorName(collaborator) {
      return collaborator.firstName + ' ' + collaborator.lastName
    },
    onRemove(idHost){
      this.chipData = this.chipData.filter((e)=> e.id !== idHost)
      this.$emit('onCollaboratorSelected', this.chipData)
    },
    onChanged(idHost) {
      this.model = Math.random().toString()
      if (this.chipData.some((e)=> e.id === idHost)) return

      const tempCollaborator = this.collaborators.filter((e)=> e.id === idHost)[0]
      this.chipData = [...this.chipData, tempCollaborator]
      this.$emit('onCollaboratorSelected', this.chipData)
    },
  },
  computed: {
    nameErrors() {
      const errors = []
      if (!this.$v.visitForm.name.$dirty) return errors
      !this.$v.visitForm.name.required && errors.push('Nombre obligatorio')
      return errors
    },
    reasonErrors() {
      const errors = []
      if (!this.$v.visitForm.reason.$dirty) return errors

      !this.$v.visitForm.reason.required && errors.push('Motivo obligatorio')
      return errors
    },

    dateErrors() {
      if (
        this.$v.visitForm.visitType.$model == 'ONLY_ONCE' &&
        this.$v.visitForm.date.$dirty &&
        !this.$v.visitForm.date.$model
      ) {
        return ['Fecha requerida']
      }
      return []
    },
    startDateErrors() {
      if (
        this.$v.visitForm.visitType.$model == 'RANGE' &&
        this.$v.visitForm.startDate.$dirty &&
        !this.$v.visitForm.startDate.$model
      ) {
        return ['Fecha requerida']
      }
      return []
    },
    endDateErrors() {
      if (
        this.$v.visitForm.visitType.$model == 'RANGE' &&
        this.$v.visitForm.endDate.$dirty &&
        !this.$v.visitForm.endDate.$model
      ) {
        return ['Fecha requerida']
      }
      return []
    },
    collaboratorErrors() {
      if (this.chipData.length === 0) {
        return ['Colaborador requerido']
      }
      return []
    },
  },
}
</script>

<style></style>
